module.exports = __webpack_public_path__ + "static/media/undraw_toy_car_7umw.0d8b2beb.svg";